



















import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {successButtonColorClass} from '@/utlitities/color';
import {UserStore} from '@/store/user-module';

    @Component({})
    export default class StToggle extends Vue {
      @Prop() value!: boolean;
      @Prop({default: 'green'}) bgClass!: string
      @Prop({default: 'left'}) type!: string;
      @Prop() disabled!: boolean;

      get successButtonColor(){
        return successButtonColorClass(UserStore.userSettings.successButtonColor)
      }

      toggle() {
        if(this.disabled){
          return;
        }
        this.$emit('input', !this.value);
      }
    }
